<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>统计管理</el-breadcrumb-item>
        <el-breadcrumb-item>报表系统</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="缺货需求汇总表" name="stockOutCollect">
          <el-row :gutter="24">
            <el-col :span="24">
              <div style="width: 95%" class="mg-auto mgt10">
                <div class="hx-form-container box-shadow">
                  <el-form ref="stockOutCollectForm" :model="listParams" label-width="100px">
                    <el-row :gutter="24">
                      <el-col :span="16">
                        <el-form-item label="日期查询：" prop="timeInterval">
                          <date-picker-group v-model="listParams.timeInterval"></date-picker-group>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="24">
                      <el-col :span="8">
                        <el-form-item label="分类名称：" prop="goodCategoryId">
                          <el-select size="small" v-model="listParams.goodCategoryId" style="width: 100%" clearable>
                            <el-option v-for="item in categoryNameList" :label="item.title" :value="item.id" :key="item.title"> </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="8">
                        <el-form-item label="供应点：" prop="logisticsSiteId">
                          <el-select size="small" v-model="listParams.logisticsSiteId" style="width: 100%">
                            <el-option v-for="item in logisticsSiteIdList" :label="item.title" :value="item.id" :key="item.title"> </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="8">
                        <el-form-item>
                          <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>

                          <el-button size="small" @click="resetForm('stockOutCollectForm')"> 重置 </el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
                <div>
                  <hx-table-result :page-sizes="[50, 100, 150]" :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
                    <div slot="action"></div>

                    <hx-table-result-col>
                      <div class="wrap-table-info-display">
                        <el-button class="align-left" type="primary" size="small" @click="exportExcel"> 导出 </el-button>
                        <span class="table-info-display">
                          <span>总条数：</span>
                          <span class="alert-text ft16">{{ pager.total }}</span>
                        </span>
                      </div>
                    </hx-table-result-col>

                    <el-table stripe slot="content" :data="tableData" max-height="800" border>
                      <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

                      <el-table-column prop="productType" align="center" label="产品类别"> </el-table-column>

                      <el-table-column prop="productName" align="center" label="产品名称"> </el-table-column>

                      <el-table-column prop="productSpec" align="center" label="产品规格"> </el-table-column>

                      <el-table-column prop="stockOutTotal" align="center" label="缺货需求合计"> </el-table-column>
                    </el-table>
                  </hx-table-result>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="销售量汇总表" name="salesCollect">
          <el-row :gutter="24">
            <el-col :span="24">
              <div style="width: 95%" class="mg-auto mgt10">
                <div class="hx-form-container box-shadow">
                  <el-form ref="salesCollectForm" :model="listParams" label-width="100px">
                    <el-row :gutter="24">
                      <el-col :span="16">
                        <el-form-item label="日期查询：" prop="timeInterval">
                          <date-picker-group v-model="listParams.timeInterval"></date-picker-group>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="24">
                      <el-col :span="8">
                        <el-form-item label="分类名称：" prop="goodCategoryId">
                          <el-select size="small" v-model="listParams.goodCategoryId" style="width: 100%" clearable>
                            <el-option v-for="item in categoryNameList" :label="item.title" :value="item.id" :key="item.title"> </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="8">
                        <el-form-item label="供应点：" prop="logisticsSiteId">
                          <el-select size="small" v-model="listParams.logisticsSiteId" style="width: 100%">
                            <el-option v-for="item in logisticsSiteIdList" :label="item.title" :value="item.id" :key="item.title"> </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="8">
                        <el-form-item>
                          <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>

                          <el-button size="small" @click="resetForm('salesCollectForm')"> 重置 </el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
                <div>
                  <hx-table-result
                    :page-sizes="[50, 100, 150]"
                    :page-info="pager"
                    :loading="tableLoading"
                    @page-current-change="handleCurrentChange"
                    @page-size-change="handleSizeChange"
                    :showPagerOnOnePage="false"
                  >
                    <div slot="action"></div>

                    <hx-table-result-col>
                      <div class="wrap-table-info-display">
                        <el-button class="align-left" type="primary" size="small" @click="exportExcel"> 导出 </el-button>
                        <span class="table-info-display">
                          <span>总条数：</span>
                          <span class="alert-text ft16">{{ pager.total }}</span>
                        </span>
                      </div>
                    </hx-table-result-col>

                    <el-table stripe slot="content" :data="tableData" max-height="800" border>
                      <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

                      <el-table-column prop="category" align="center" label="产品类别"> </el-table-column>

                      <el-table-column prop="goodTitle" align="center" label="产品名称"> </el-table-column>

                      <el-table-column prop="spec" align="center" label="产品规格"> </el-table-column>

                      <el-table-column prop="saleNumber" align="center" label="销售量合计"> </el-table-column>
                    </el-table>
                  </hx-table-result>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="供应点接收登记表" name="receiveRegister">
          <el-row :gutter="24">
            <el-col :span="24">
              <div style="width: 95%" class="mg-auto mgt10">
                <div class="hx-form-container box-shadow">
                  <el-form ref="salesCollectForm" :model="listParams" label-width="100px">
                    <el-row :gutter="24">
                      <el-col :span="16">
                        <el-form-item label="日期查询：" prop="timeInterval">
                          <date-picker-group v-model="listParams.timeInterval"></date-picker-group>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="24">
                      <el-col :span="8">
                        <el-form-item label="分类名称：" prop="goodCategoryId">
                          <el-select size="small" v-model="listParams.goodCategoryId" style="width: 100%" clearable>
                            <el-option v-for="item in categoryNameList" :label="item.title" :value="item.id" :key="item.title"> </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="8">
                        <el-form-item label="供应点：" prop="logisticsSiteId">
                          <el-select size="small" v-model="listParams.logisticsSiteId" style="width: 100%">
                            <el-option v-for="item in logisticsSiteIdList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="8">
                        <el-form-item>
                          <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>

                          <el-button size="small" @click="resetForm('receiveRegister')"> 重置 </el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
                <div>
                  <hx-table-result :page-sizes="[50, 100, 150]" :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
                    <div slot="action"></div>

                    <hx-table-result-col>
                      <div class="wrap-table-info-display">
                        <el-button class="align-left" type="primary" size="small" @click="exportExcel"> 导出 </el-button>
                        <span class="table-info-display">
                          <span>总条数：</span>
                          <span class="alert-text ft16">{{ pager.total }}</span>
                        </span>
                      </div>
                    </hx-table-result-col>

                    <el-table stripe slot="content" :data="tableData" max-height="800" border>
                      <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

                      <el-table-column prop="productType" align="center" label="产品类别"> </el-table-column>

                      <el-table-column prop="productName" align="center" label="产品名称"> </el-table-column>

                      <el-table-column prop="productSpec" align="center" label="产品规格"> </el-table-column>

                      <el-table-column prop="quantityDemanded" align="center" label="需求量"> </el-table-column>

                      <el-table-column width="100" v-for="(item, index) in baseNameList" :key="index" align="center" :label="item.title">
                        <template slot-scope="scope">
                          {{ scope.row.baseList[index] }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </hx-table-result>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { download } from "../../../../../utils/javascript/download";

export default {
  data() {
    return {
      activeName: "stockOutCollect",
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 50,
        total: 0,
      },
      url: "/statistic/site/want/search",
      exportUrl: "/statistic/site/want/export",
      tableLoading: false,
      categoryNameList: [],
      logisticsSiteIdList: [],
      listParams: {
        supplyId: "",
        goodCategoryId: "",
        logisticsSiteId: "",
        timeInterval: [new Date().getTime() - 31 * 24 * 60 * 60 * 1000, Date.parse(new Date())],
      },
      initListParams: {
        goodCategoryId: "",
        logisticsSiteId: "",
        timeInterval: [new Date().getTime() - 31 * 24 * 60 * 60 * 1000, Date.parse(new Date())],
      },
      baseNameList: [],
    };
  },
  mounted() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.loadCategoryList();
    this.loadLogisticsSiteIdList();
  },
  methods: {
    /**
     * 初始化加载分类名称
     */
    loadCategoryList() {
      this.$http({
        url: global.apiUrl + "/good/goodcategory/findAll",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            const dataList = res.body.data;
            dataList.unshift({ id: "", title: "全部" });
            this.categoryNameList = dataList;
          } else {
            this.categoryNameList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化供应点列表
     */
    loadLogisticsSiteIdList() {
      this.$http({
        url: global.apiUrl + "/logistics/index",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.logisticsSiteIdList = res.body.data.dataList;
            this.listParams.logisticsSiteId = this.logisticsSiteIdList[0].id;
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * tab switch事件
     * @param tab
     * @param e
     */
    handleClick(tab, e) {
      this.listParams = this.initListParams;
      this.listParams.supplyId = this.$route.params.supplyId;
      switch (this.activeName) {
        case "stockOutCollect":
          this.url = "/statistic/site/want/search";
          this.exportUrl = "/statistic/site/want/export";
          break;
        case "salesCollect":
          this.url = "/statistic/site/sale/search";
          this.exportUrl = "/statistic/site/sale/export";
          break;
        case "receiveRegister":
          this.url = "/statistic/site/receive/search";
          this.exportUrl = "/statistic/site/receive/export";
          this.loadBaseNameList();
          break;
      }
      this.loadCategoryList();
      this.loadLogisticsSiteIdList();
    },
    /**
     * 加载table数据列表
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
      });
      bodyParams.startDate = bodyParams.timeInterval[0];
      bodyParams.endDate = bodyParams.timeInterval[1];
      delete bodyParams.timeInterval;
      this.$http({
        url: global.apiUrl + this.url,
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              if (this.activeName == "salesCollect") {
                this.tableData = res.body.data;
                this.pager.total = res.body.data.length;
                return;
              }
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 初始化基地名称列表
     */
    loadBaseNameList() {
      this.$http({
        url: global.apiUrl + "/farm/title",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.baseNameList = res.body.data.dataList;
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 重置请求表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
      this.listParams.logisticsSiteId = 1;
    },
    /**
     * 导出Excel表
     */
    exportExcel() {
      download(
        this.exportUrl,
        {
          logisticsSiteId: this.listParams.logisticsSiteId,
          supplyId: this.listParams.supplyId,
        },
        "报表系统"
      );

      // this.$router.open({
      //   path: this.exportUrl,
      //   query: {
      //     logisticsSiteId: this.listParams.logisticsSiteId,
      //     supplyId: this.listParams.supplyId
      //   },
      //   type: "excel"
      // });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
  watch: {
    "listParams.logisticsSiteId": function (val, oldVal) {
      if (val !== oldVal) {
        this.pager.pageIndex = 1;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
